export default "__VITE_PUBLIC_ASSET__636bdc7b__"